import { Countries } from "@utils/enums";

const variableRegex = /{\d+}/g;

const CountryNames = {
    NL: {
        BE: "België",
        FR: "Frankrijk",
    },
    FR: {
        BE: "Belgique",
        FR: "France",
    },
};

export const parseCountryToISO = (country: string) => {
    let parsedCountry = "";

    // This is ugly, BE should send prefixed phonenumbers to us for store data
    // eslint-disable-next-line smells/no-switch
    switch (country) {
        case CountryNames.NL.BE:
        case CountryNames.FR.BE:
            parsedCountry = Countries.BE;
            break;
        case CountryNames.NL.FR:
        case CountryNames.FR.FR:
            parsedCountry = Countries.FR;
            break;
    }

    return parsedCountry;
};

export const variableText = (inp: any, ...args: any) => {
    let input = inp;
    const matches = [...inp.matchAll(variableRegex)];
    matches.map((match, index) => {
        input = input.replace(match[0], args[index]);
    });

    return input;
};

export function noEmptyValueFormatter(propValue: any, propCheck: any) {
    return propCheck ? propValue : "/";
}

export const underScoreToCamelCase = (str: string): string => {
    return str
        .toLowerCase()
        .replace(/_[a-zA-Z]/g, x => {
            return x.toUpperCase();
        })
        .replaceAll("_", "");
};

export const cleanUp = (str: string, stripSpaces: boolean = false): string => {
    const cleaned = str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^\w\s]/gi, "");

    if (stripSpaces) {
        return cleaned.replace(/ /g, "");
    }
    return cleaned;
};

export const padStart = (
    str: string = "",
    length: number = 0,
    chars: string = "",
) => {
    return str.padStart(length, chars);
};

export const applyHighlight = (
    prefix: string,
    postfix: string,
    input?: string,
    matchedHighlights: woosmap.map.AutocompleteMatchedSubstring[] = [],
) => {
    if (!input) return "";

    return matchedHighlights.reduce((acc, offsets, index) => {
        const strOffset = index * (prefix.length + postfix.length);

        return (
            acc.substring(0, offsets.offset + strOffset) +
            prefix +
            acc.substring(
                offsets.offset + strOffset,
                offsets.length + offsets.offset + strOffset,
            ) +
            postfix +
            acc.substring(offsets.offset + offsets.length + strOffset)
        );
    }, input);
};
